import { useEffect, useState } from "react";
import { useAppContext } from "context/app-context";
import { ReactHelmetWithProvider } from "./ReactHelmetProvider";
import { eraseCookie, getCookie, setCookie } from "services/cookies";

export const InsertDecagonProvider = () => {
  const [hasDecagonMetadata, setHasDecagonMetadata] = useState(false);
  const { sessionInfo } = useAppContext();

  useEffect(() => {
    if (!hasDecagonMetadata && window.duet && sessionInfo.userID) {
      // Set Metadata
      const userId = sessionInfo.isLoggedIn
        ? sessionInfo.userID
        : `guest-${sessionInfo.userID}`;

      window.duet.setUserId(userId);
      window.duet.setMetadata({
        userId: userId,
        token: window.btoa(userId)
      });
      setHasDecagonMetadata(true);

      // Open Decagon if it was already open
      const decagonOpen = getCookie("decagon_open");
      if (decagonOpen === "true") {
        window.duet.open();
      }

      // Add opening and closing listeners
      window.duet.setEventListener(({ eventName }) => {
        if (eventName === "DUET_INITIALIZE")
          setCookie({ name: "decagon_open", value: true });
        if (eventName === "DUET_DEINITIALIZE") eraseCookie("decagon_open");
      });
    }
  }, [hasDecagonMetadata, sessionInfo]);
  return (
    <>
      <ReactHelmetWithProvider
        helmetOptions={{
          async: true,
          script: [{ src: "https://decagon.ai/loaders/raise.js" }]
        }}
      ></ReactHelmetWithProvider>
    </>
  );
};
